import { bool, func } from "prop-types";
import { forwardRef } from "react";

import styled from "styled-components/macro";

import FnrIcon from "UI/FnrIcon/FnrIcon";

const SDiv = styled("div")`
  ${({
    $show,
    theme: {
      colors: { divider },
    },
  }) => `cursor: move;
    cursor: grab;
    color: ${divider};
    opacity: ${$show ? 1 : 0};
    transition: opacity .2s;
    
    &:active {
    cursor: move;
    cursor: grabbing;
    }`}
`;

const FnrSortHandle = forwardRef(({ show, onPointerDown, ...rest }, ref) => (
  <SDiv $show={show} onPointerDown={onPointerDown} {...rest} ref={ref}>
    <FnrIcon icon="sort fas" />
  </SDiv>
));

FnrSortHandle.propTypes = {
  show: bool,
  onPointerDown: func,
};

export default FnrSortHandle;
